<div class="filter-box filter-box--col-{{ col}} {{ appendClass }}">
  <div class="filter-box__title">{{ title }}</div>
  <div class="filter-box__content">
    <ng-content></ng-content>
  </div>
</div>